<div class="row col-12">
  <input
    type="checkbox"
    class="styled-checkbox"
    [name]="name"
    [id]="id"
    [value]="value"
    [(ngModel)]="value"
    #i="ngModel"
    (change)="onChange($event)" />
  <label class="text-center pl-2 pt-0">{{ checkBoxMessage }}</label>
</div>
